import { Checkbox } from "@nextui-org/react";
const examtablecolumn = [
  {
    key: "num",
    label: "SN.",
  },
  {
    key: "name",
    label: "Name",
  },
  {
    key: "noOfQuestions",
    label: "Number of Questions",
  },
  {
    key: "totalTime",
    label: "Total Time",
  },
  {
    key: "isLive",
    label: "Status",
  },
  {
    key: "actions",
    label: "Actions",
  },
];

export { examtablecolumn };
